import React from 'react';
import { ArrowDownIcon, ArrowRightIcon } from 'lucide-react';
import { Section, SectionTitle } from '../Section';
import { CTAButton } from '../CTAButton';
import { transformationRows } from '../../data/landing';
export function TransformationSection() {
  return <Section tone="wine" id="transformacion" wide data-id="element-103" data-mp="3hwhkq40wypj4">
      <SectionTitle className="text-center md:text-[3.75rem]" data-id="element-104" data-mp="3mygq1jg7rwip">
        Antes y después de <span className="italic text-gold" data-id="element-105" data-mp="ehc6j709hhbl">INOLVIDABLE</span>
      </SectionTitle>

      <div className="mt-10 md:mt-14" data-id="element-106" data-mp="jggfpxn6rf1x">
        <div className="hidden grid-cols-[1fr_48px_1fr] pb-4 text-[13px] font-medium uppercase tracking-[0.2em] md:grid" data-id="element-107" data-mp="jfdqdu5ihko4">
          <span className="text-ivory/50" data-id="element-108" data-mp="5gnom17qywtf">Antes</span>
          <span aria-hidden="true" data-id="element-109" data-mp="9hr8cysx1czx" />
          <span className="pl-6 text-gold" data-id="element-110" data-mp="9gpj9qf2epz7">Después</span>
        </div>

        <ul className="space-y-6 md:space-y-3" data-id="element-111" data-mp="2q63dgqneobgf">
          {transformationRows.map(row => <li key={row.before} className="flex flex-col items-stretch md:grid md:grid-cols-[1fr_48px_1fr] md:items-center" data-id="element-112" data-mp="2u9t03akisiyt">
              <div className="rounded-xl bg-ink/40 px-5 py-4 md:bg-transparent md:px-0 md:py-5" data-id="element-113" data-mp="2h5ws6n3bp05h">
                <span className="text-[12px] font-medium uppercase tracking-[0.2em] text-ivory/45 md:hidden" data-id="element-114" data-mp="2c7v1ph3khyjz">Antes</span>
                <p className="mt-1 text-base leading-relaxed text-ivory/55 md:mt-0 md:text-[17px]" data-id="element-115" data-mp="2q3ytl3qyxuta">{row.before}</p>
              </div>
              <div className="flex justify-center py-2 md:py-0" aria-hidden="true" data-id="element-116" data-mp="303pkywk8ftp5">
                <ArrowDownIcon strokeWidth={1.5} className="h-5 w-5 text-gold md:hidden" data-id="element-117" data-mp="2v5fqko6c0x4l" />
                <ArrowRightIcon strokeWidth={1.5} className="hidden h-6 w-6 text-gold md:block" data-id="element-118" data-mp="39u2g1ipob59j" />
              </div>
              <div className="rounded-xl border-2 border-gold bg-ivory px-5 py-4 md:py-5" data-id="element-119" data-mp="34ufr4c0hg0kw">
                <span className="text-[12px] font-semibold uppercase tracking-[0.2em] text-wine md:hidden" data-id="element-120" data-mp="3iuh3ooq40wg7">Después</span>
                <p className="mt-1 font-serif text-[1.3rem] font-medium leading-snug text-ink md:mt-0 md:text-[1.45rem]" data-id="element-121" data-mp="3dwfahayyzgr0">
                  {row.after}
                </p>
              </div>
            </li>)}
        </ul>
      </div>

      <p className="mx-auto mt-12 max-w-[560px] text-center font-serif text-[1.75rem] italic leading-snug text-gold md:text-[2.1rem]" data-id="element-122" data-mp="2ghknoz8qh6c7">
        No es magia. Es anatomía, técnica y práctica.
      </p>
      <div className="mt-8 text-center" data-id="element-123" data-mp="2paxosogybe9d">
        <CTAButton data-id="element-124" data-mp="2u98ucn07r2ls" />
      </div>
    </Section>;
}